import {
  ActivatePartnershipInput,
  CheckPartnershipInput,
} from "@/domain/dtos/inputs/";
import { PartnershipValidation } from "@/domain/entities";
import { PartnershipMapper } from "@/domain/mappers";
import { PartnershipRepository } from "@/domain/repositories";
import { PartnershipDataSource } from "../datasources/partnership";
import { PartnershipValidationResponse } from "../dtos/responses";

export class PartnershipRepoImpl implements PartnershipRepository {
  constructor(
    private readonly dataSource: PartnershipDataSource,
    private readonly mapper: PartnershipMapper<PartnershipValidationResponse>,
    // private readonly minimumAppointmentPrice: number,
  ) {}

  async checkPartnership(
    params: CheckPartnershipInput,
  ): Promise<PartnershipValidation> {
    const data = await this.dataSource.checkPartnership(params);
    return this.mapper.toDomain(data);
  }

  // calculatePriceForPartnership(params: CalculatePartnershipPriceInput): AppointmentPrices {
  //   const { discount_percentage, appointment_price } = params;

  //   let percentage = discount_percentage ?? 0;
  //   if (percentage < 0 || isNaN(percentage)) {
  //     percentage = 0;
  //   }

  //   const discountPercentage = percentage / 100;
  //   const totalDiscount = appointment_price * discountPercentage;
  //   let appointmentNewPrice = appointment_price - totalDiscount;
  //   let benefitValue = totalDiscount;

  //   if (appointmentNewPrice < this.minimumAppointmentPrice) {
  //     appointmentNewPrice = this.minimumAppointmentPrice;
  //     benefitValue = appointment_price - this.minimumAppointmentPrice;
  //   }

  //   return { appointmentNewPrice, benefitValue };
  // }

  async activatePartnership(
    params: ActivatePartnershipInput,
  ): Promise<{ message: string }> {
    return this.dataSource.activatePartnership(params);
  }

  async removePartnership(partnershipId: number): Promise<{ message: string }> {
    return this.dataSource.removePartnership(partnershipId);
  }
}
